import React from 'react';
import { LOGOUT_IMG } from '../../../utills/image-constant';

const LogoutModel = ({ title, LogoutModel, handleAdminLogout }) => {

  return (
    <div className="logoutModel">
      <button type="button" className="d-none btn btn-primary" data-bs-toggle="modal" data-bs-target="#logoutmodel" ref={LogoutModel}>
      </button>

      <div className="modal fade logout_body" id="logoutmodel" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header logout_header">
              <img src={LOGOUT_IMG} alt='Logout Icon' className='img-fluid' />
            </div>
            <div className="modal-body border-0">
              <h5 className="modal-title text-danger" id="staticBackdropLabel">{title}</h5>
            </div>
            <div className="modal-footer logout_footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={handleAdminLogout}>Confirm</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutModel;
